import { CommonModule } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from "@angular/core";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";

import { BreadcrumbSection } from "../../models/breadcrumb.model";
import { BreadcrumbHeadService } from "../../services/breadcrumb-head.service";

import { computeBreadcrumbClickable } from "./breadcrumb.helpers";

@Component({
    selector: "h-breadcrumb",
    templateUrl: "./breadcrumb.component.html",
    styleUrls: ["./breadcrumb.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, SrOnlyNoSnippetDirective],
    standalone: true,
})
export class BreadcrumbComponent {
    /**
     * Breadcrumb title that should be translated for SEO and a11y
     */
    @Input({ required: true })
    public breadcrumbTitle!: string;

    @Output()
    public clickEvent = new EventEmitter<string>();

    public breadcrumbSectionsDisplayed: BreadcrumbSection[] = [];

    constructor(private breadcrumbHeadService: BreadcrumbHeadService) {}

    @Input({ required: true })
    public set breadcrumbSections(breadcrumbSections: BreadcrumbSection[]) {
        this.breadcrumbSectionsDisplayed =
            computeBreadcrumbClickable(breadcrumbSections);
        this.addBreadcrumbStructuredData(breadcrumbSections);
    }

    public sendClickEvent(
        event: MouseEvent,
        breadcrumbSection: BreadcrumbSection,
    ): void {
        event.preventDefault();
        if (!breadcrumbSection.unclickable) {
            this.clickEvent.emit(breadcrumbSection.url);
        }
    }

    /**
     * Stuctured data needed for SEO breadcrumb.
     * Search engine uses breadcrumb markup in the body of a web page to categorize the information from the page in search results
     */
    public addBreadcrumbStructuredData(
        breadcrumbSections: BreadcrumbSection[],
    ): void {
        this.breadcrumbHeadService.addBreadcrumbStructuredData(
            breadcrumbSections,
        );
    }
}
